import styled, { css } from 'styled-components';
import calendarIcon from 'images/calendarIconBlue.svg';
import categoryIcon from 'images/categoryIconBlue.svg';
import searchIcon from 'images/searchIconBlue.svg';
import { absFull } from 'helpers/styles.js';

const tagTypeIconMap = {
  search: searchIcon,
  category: categoryIcon,
  date: calendarIcon,
};

export const StyledTag = styled.span`
  display: inline-block;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 6px 10px;
  margin: 4px 8px 4px 0;
  border-radius: 20px;
  position: relative;
  line-height: 14px;
  height: 27px;
  font-size: 9px;
  max-width: 120px;
  border: ${({ theme }) => `1px solid ${theme.colors.palette[7]}}`};
  padding-right: ${({ deleteEnabled }) => deleteEnabled ? '32px' : '10px'};
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  color: ${({ theme }) => theme.colors.palette[7]};
  background-color: transparent;

  &:hover {
    color: white;
    background-color: ${({ theme }) => theme.colors.palette[7]};
  }

  ${({ type, theme }) => type === 'topics' && css`
    color: ${theme.colors.palette[3]};

    &:hover {
      background-color: ${theme.colors.palette[3]};
    }
  `}

  ${({ type }) => type === 'keyword' && css`
    color: white;
    background-color: ${({ theme }) => theme.colors.palette[7]};
  `}

  ${({ clickable }) => !clickable && css`
    color: white;
    background-color: ${({ theme }) => theme.colors.palette[7]};
  `}

  ${({ type }) => type === 'date' && css`
    max-width: 200px;
  `}

  ${({ icon }) => icon && css`
    padding-left: 28px;
  `}
`;

export const TagText = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: top;

  &:hover {
    color: white;
  }
`;

export const SelectedTag = styled(StyledTag)`
  background-image: ${({ type }) => tagTypeIconMap[type] ? `url('${tagTypeIconMap[type]}')` : 'none'};
  background-repeat: no-repeat;
  padding: 0 30px;
  background-position-x: 11px;
  background-position-y: 7px;
  line-height: 25px;
  color: black;
  background-color: #F3F4F5;
  border: solid 1px #F3F4F5;

  &:hover {
    cursor: ${props => props.clickable ? 'pointer' : 'default'};
    background-color: #F3F4F5;
    color: black;
  }

  ${({ type }) => type === 'keyword' && css`
    max-width: 100%;
    background: none;
    padding-left: 12px;
    padding-right: ${({ deleteEnabled }) => deleteEnabled ? '32px' : '12px'};
    letter-spacing: 1px;
    text-transform: uppercase;
    color: white;
    background-color: ${({ theme }) => theme.colors.palette[7]};
    border-color: ${({ theme }) => theme.colors.palette[7]};

    &:hover {
      background-color: #1472E5;
      border-color: #1472E5;
      color: white;

      ${TagText} {
        color: white;
      }
    }
  `}

  ${({ type }) => type === 'content' && css`
    padding-left: 12px;
    padding-right: ${({ deleteEnabled }) => deleteEnabled ? '32px' : '12px'};
    letter-spacing: 1px;
    text-transform: uppercase;
  `}
`;

export const StyledIcon = styled.div`
  background: ${({ url }) => `url('${url}')`};
  background-size: contain;
  background-color: white;
  background-position: center center;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  ${absFull('5px', 'auto', 'auto', '7px')};
`;

export const StyledTagDeleteButton = styled.span`
  position: absolute;
  top: 5px;
  right: 7px;
  bottom: auto;
  left: auto;
  color: white;
  background: rgba(0, 0, 0, 0.16);
  border-radius: 100%;
  width: 15px;
  height: 14px;
  line-height: 18px;
  font-size: 14px;
  text-align: center;
`;
